import React from 'react';

import style from './VolumeControls.module.scss';

const VolumeControls = ({
  currVolume,
  handleVolumeVisibility,
  isVolumeOpen,
  handleVolumeLevel,
}) => {
  return (
    <div className={style.volumeWrapper}>
      <div
        className={`${
          currVolume <= '0.50' && currVolume >= '0.05'
            ? style.volumeButtonHalf
            : currVolume === '0' ? style.volumeButtonMuted : ''
        } ${style.volumeButton}`}
        onClick={handleVolumeVisibility}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17.5">
          <path d="M0,5.8v6h4l5,5v-16l-5,5H0z" />
          <g className={style.volumeBars}>
            <path d="M11,0v2.1c2.9,0.9,5,3.5,5,6.7s-2.1,5.9-5,6.7v2.1c4-0.9,7-4.5,7-8.8S15,0.9,11,0L11,0z" />
            <path d="M13.5,8.8c0-1.8-1-3.3-2.5-4v8C12.5,12.1,13.5,10.5,13.5,8.8z" />
          </g>
        </svg>
      </div>
      <div
        className={`volume-slider ${
          isVolumeOpen ? style.volumeSliderOpen : ''
        } ${style.volumeSlider}`}
      >
        <input
          type="range"
          min="0"
          max="1"
          step="0.05"
          onChange={handleVolumeLevel}
        />
      </div>
    </div>
  );
};

export default VolumeControls;



// WEBPACK FOOTER //
// ./src/components/ui/VolumeControls.js